import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

import { ToggleOptions } from '../contribution.types';

interface Props {
  toggleOptions: ToggleOptions[];
  selectedOption: ToggleOptions;
  setSelectedOption: (value: ToggleOptions) => void;
}

export const MakeContributionModalToggler: React.FC<Props> = ({
  toggleOptions,
  selectedOption,
  setSelectedOption,
}) => {
  const isSelectedOption = (option: string) => option === selectedOption;
  return (
    <Box
      data-testid="MakeContributionModalToggler_container"
      round="container1Round"
      pad="spacing4"
      background="module"
      direction="row"
      width={{ min: 'fit-content', max: 'fit-content' }}
    >
      {toggleOptions.map((option) => (
        <Box
          data-testid="MakeContributionModalToggler_item"
          key={option}
          width={{ min: '170px', max: 'fit-content' }}
          height={{ min: '40px', max: 'fit-content' }}
          align="center"
          justify="center"
          background={{ color: isSelectedOption(option) ? 'canvas' : 'transparent' }}
          border={{ color: isSelectedOption(option) ? 'border2' : 'transparent' }}
          round="container2Round"
          onClick={() => setSelectedOption(option)}
        >
          <Text
            weight={isSelectedOption(option) ? 700 : 400}
            color={isSelectedOption(option) ? 'textBody' : 'textAccent'}
          >
            {option}
          </Text>
        </Box>
      ))}
    </Box>
  );
};
